import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { restore } from "./../../../../assets/json/restoreTooltip.en";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";

@Component({
  standalone: false,
  selector: "app-psu-feature",
  templateUrl: "./psu-feature.component.html",
  styleUrls: ["./psu-feature.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PsuFeatureComponent extends FieldType implements OnInit {
  @Input() field;
  psuParameter = [];
  defaultValue;
  checkboxdefaultValue;
  paramterCheckedValue;
  selectedParameter = [];
  hearBeat;
  gaspValue;
  paramterCheckedValueHB: boolean;
  paramterCheckedValueLG;
  defaultRestoring;
  countparam = 0;
  countparamLG = 0;
  restoreText = restore;
  fileResponse: LegacyAny;
  countArray: LegacyAny = [];
  ngModelval: LegacyAny = {};
  properties;
  isEdited: LegacyAny;
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }
  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const touchDimObj = Object.assign({}, value);
    this.appState.setFeatureData(keyVal, touchDimObj);
  }
  ngOnInit() {
    this.isEdited = false;
    this.featureDefaults.getSrPsuDefaultValue.subscribe((response) => {
      if (response) {
        this.resetDefault();
        this.countArray = [];
      }
    });

    // Use centralized method to get feature data
    // This automatically prioritizes SaveSetData over ConfigurationData
    const psuData = this.appState.getFeatureData('DALIPSU') || this.appState.getFeatureData('SrPsu');
    if (psuData) {
      this.fileResponse = { resp: {} };
      // Use the correct key based on which one was found
      const keyName = this.appState.getFeatureData('DALIPSU') ? 'DALIPSU' : 'SrPsu';
      this.fileResponse.resp[keyName] = psuData;
    }

    this.properties = this.field;
    let reqPSUEable = false;
    let reqHeartBeat = false;
    let reqLastGasp = false;

    const reqProps = this.field.requiredProperties;
    reqProps.forEach((element) => {
      if (element === "Enabled") reqPSUEable = true;
      if (element === "HbEnable") reqHeartBeat = true;
      if (element === "LastGaspEnable") reqLastGasp = true;
    });
    if (this.field.properties.Enabled && reqPSUEable) {
      this.ngModelval["Enabled"] = this.field.properties.Enabled.default;
      this.rSetChanged(this.ngModelval["Enabled"]);
    }
    if (this.field.properties.HbEnable && reqHeartBeat) {
      this.ngModelval["HbEnable"] = this.field.properties.HbEnable.default;
      this.paramterCheckedValueHB = this.ngModelval["HbEnable"];
      this.psuParameter.push("Heart beat");
    }
    if (this.field.properties.LastGaspEnable && reqLastGasp) {
      this.ngModelval["LastGaspEnable"] =
        this.field.properties.LastGaspEnable.default;
      this.paramterCheckedValueLG = this.ngModelval["LastGaspEnable"];
      this.psuParameter.push("Last gasp");
    }
    ////
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();

    let featIndex: number = 0;
    if (unSelectedFeat != null && unSelectedFeat.length > 0) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "DALIPSU") {
          this.fileResponse = {};
          const srPsuUnSelected: LegacyAny = element["featureParameters"][0];
          const SRPSEditedData = {
            resp: {
              SrPsu: srPsuUnSelected,
            },
          };
          this.fileResponse = SRPSEditedData;
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    /////
    let daliPSUname = "SrPsu";
    if (
      this.fileResponse &&
      this.fileResponse["resp"] &&
      this.fileResponse["resp"].DALIPSU
    )
      daliPSUname = "DALIPSU";

    if (
      this.fileResponse &&
      this.fileResponse["resp"] &&
      this.fileResponse["resp"][daliPSUname]
    ) {
      for (const key in this.fileResponse["resp"][daliPSUname]) {
        if (key === "Enabled") {
          this.rSetChanged(this.fileResponse["resp"][daliPSUname][key]);
        } else {
          let keyObj;
          let heartBeat_LastGasp = false;
          if (key === "HbEnable") {
            keyObj = "Heart beat";
            heartBeat_LastGasp = true;
          } else if (key === "LastGaspEnable") {
            keyObj = "Last gasp";
            heartBeat_LastGasp = true;
          }
          if (heartBeat_LastGasp)
            this.paramterChecked(
              this.fileResponse["resp"][daliPSUname][key],
              keyObj
            );
        }
      }
    }
    this.checkDefault();
    this.sentPSUEnable(this.ngModelval);
    this.isEdited = true;
  }
  sentPSUEnable(val) {
    this.aloAoc.sentPSUEnable(val);
    if (this.isEdited) {
      this.setConfigurationData(val, "DALIPSU");
    }
  }
  paramterChecked(event, param) {
    if (param === "Heart beat") {
      this.ngModelval["HbEnable"] = this.paramterCheckedValueHB = event;
    }
    if (param === "Last gasp") {
      this.ngModelval["LastGaspEnable"] = this.paramterCheckedValueLG = event;
    }
    this.checkDefault();
    this.sentPSUEnable(this.ngModelval);
    this.featureDefaults.setSrpsuDefaultColor(this.defaultRestoring);
  }

  rSetChanged(event) {
    if (event) {
      this.ngModelval["Enabled"] = event;
      this.checkboxdefaultValue = true;
    } else {
      this.ngModelval["Enabled"] = event;
      this.checkboxdefaultValue = false;
    }
    this.checkDefault();
    this.sentPSUEnable(this.ngModelval);
    this.featureDefaults.setSrpsuDefaultColor(this.defaultRestoring);
  }

  checkDefault() {
    let newtype;
    this.defaultRestoring = true;
    for (const type in this.ngModelval) {
      newtype = type.replace("Val", "");
      if (this.properties &&
        this.properties.properties[newtype] &&
        this.properties.properties[newtype]["default"] != null &&
        this.ngModelval[type] != this.properties.properties[newtype]["default"]
      ) {
        this.defaultRestoring = false;
      }
    }
    this.featureDefaults.setSrpsuDefaultColor(this.defaultRestoring);
  }

  resetDefault() {
    if (this.field.properties.Enabled) {
      this.ngModelval["Enabled"] = this.field.properties.Enabled.default;
      this.checkboxdefaultValue = true;
    }
    if (this.field.properties.HbEnable) {
      this.ngModelval["HbEnable"] = this.field.properties.HbEnable.default;
      this.paramterCheckedValueHB = this.ngModelval["HbEnable"];
    }
    if (this.field.properties.LastGaspEnable) {
      this.ngModelval["LastGaspEnable"] =
        this.field.properties.LastGaspEnable.default;
      this.paramterCheckedValueLG = this.ngModelval["LastGaspEnable"];
    }
    this.sentPSUEnable(this.ngModelval);
    this.defaultRestoring = true;
    this.featureDefaults.setSrpsuDefaultColor(this.defaultRestoring);
    this.ref.markForCheck();
  }
}

